module.exports = __webpack_public_path__ + "img/3.190bc1fe.png";